export enum SearchMode {
  RECHTE_REGISTER_SEARCH,
  GRUNDSTEUCK_REGISTER_SEARCH,
  GRUNDBUCHGESCHAEFT_SEARCH,
  GRUNDBUCHMELDUNG_REGISTER_SEARCH,
  GEOMETERGESCHAEFT_SEARCH,
  GWR_BAUPROJEKT_SEARCH,
  GWR_GEBAEUDE_SEARCH
}
